import { render, staticRenderFns } from "./Studio404.vue?vue&type=template&id=56d3e94a&scoped=true&"
import script from "./Studio404.vue?vue&type=script&lang=js&"
export * from "./Studio404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d3e94a",
  null
  
)

export default component.exports